import { useMutation } from "@apollo/client"
import { TOURNAMENT_EDIT } from "../queries/tournamentEdit"
import { useToast } from "@/hooks/use-toast"

export interface TournamentRelatedInput {
  relatedId: number
  quotas: number
}

export interface TournamentEditInput {
  id: number
  name: string
  description: string
  image?: string
  eventUrl?: string
  addressId?: number
  typeId: number
  gameId: number
  seasonId?: number
  formatId: number
  startDate: string
  storeId: number
  validDates?: number
  private?: number
  isPresential?: number
  relateds?: TournamentRelatedInput[]
}

export const useTournamentEdit = () => {
  const { toast } = useToast()

  const [edit, { loading, error }] = useMutation(TOURNAMENT_EDIT, {
    onCompleted: (data) => {
      if (data.TournamentEdit.status.success) {
        toast({
          title: "Torneo actualizado",
          description: "El torneo ha sido actualizado exitosamente.",
          variant: "success",
        })
      } else {
        toast({
          title: "Error al actualizar torneo",
          description: data.TournamentEdit.status.detail || "Ha ocurrido un error inesperado.",
          variant: "destructive",
        })
      }
    },
    onError: (error) => {
      toast({
        title: "Error al actualizar torneo",
        description: error.message || "Ha ocurrido un error inesperado.",
        variant: "destructive",
      })
    },
  })

  const editTournament = async (input: TournamentEditInput) => {
    try {
      const response = await edit({
        variables: { TournamentEditInput: input },
      })
      return response.data?.TournamentEdit
    } catch (err) {
      console.error("Error editing tournament:", err)
      throw err
    }
  }

  return {
    editTournament,
    loading,
    error,
  }
}
